/**
 * Live Shopping Feed
 * - Ticks the "buyers online" number up/down gently to feel live.
 * - Auto-scrolls the product track, pausing on hover/touch/focus.
 * - Wires up prev/next arrows.
 * Scoped per-section so multiple instances on one page don't conflict.
 */
(function () {
  function initSection(section) {
    initCounter(section);
    initTrack(section);
  }

  function initCounter(section) {
    var el = section.querySelector('[data-lsf-counter]');
    if (!el) return;

    var base = parseInt(el.getAttribute('data-base'), 10) || 15000;
    var current = base;

    function tick() {
      // small realistic wobble, biased back toward base so it never drifts far
      var drift = base - current;
      var pull = Math.round(drift * 0.15);
      var wobble = Math.floor(Math.random() * 9) - 4; // -4..4
      current = current + pull + wobble;
      el.textContent = current.toLocaleString('fr-FR');
    }

    var interval = setInterval(tick, 2600);

    // Pause the ticker if the tab isn't visible, resume when it is
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearInterval(interval);
      } else {
        interval = setInterval(tick, 2600);
      }
    });
  }

  function initTrack(section) {
    var track = section.querySelector('[data-lsf-track]');
    var prevBtn = section.querySelector('[data-lsf-prev]');
    var nextBtn = section.querySelector('[data-lsf-next]');
    if (!track) return;

    var settings = section.dataset;
    var autoscroll = section.querySelector('.lsf').dataset.autoscroll !== 'false';
    var speed = 0.6; // px per frame baseline, adjusted below if configured
    var speedAttr = section.getAttribute('data-scroll-speed');
    if (speedAttr) speed = parseFloat(speedAttr) / 40;

    function cardWidth() {
      var card = track.querySelector('.lsf__card');
      if (!card) return 260;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.gap) || 20;
      return card.getBoundingClientRect().width + gap;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
      });
    }

    // Auto-scroll loop, pauses on interaction
    var paused = false;
    var rafId;

    function step() {
      if (!paused) {
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        if (atEnd) {
          track.scrollLeft = 0;
        } else {
          track.scrollLeft += speed;
        }
      }
      rafId = requestAnimationFrame(step);
    }

    function pause() { paused = true; }
    function resume() { paused = false; }

    ['mouseenter', 'touchstart', 'focusin'].forEach(function (evt) {
      track.addEventListener(evt, pause, { passive: true });
    });
    ['mouseleave', 'touchend', 'focusout'].forEach(function (evt) {
      track.addEventListener(evt, resume, { passive: true });
    });

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (autoscroll && !reducedMotion) {
      rafId = requestAnimationFrame(step);
    }
  }

  function boot() {
    document.querySelectorAll('.lsf').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when added/edited via the Theme Editor
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.lsf');
    if (section) initSection(section);
  });
})();